import type { Step } from "react-joyride";

export const documentsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າເອກະສານການເງິນ. ທ່ານສາມາດຈັດການລາຄາ, ໃບບິນ ແລະ ໃບຮັບເງິນທັງໝົດຈາກຫນ້ານີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="documents-toolbar"]',
    content:
      "ກົດປຸ່ມນີ້ເພື່ອສ້າງເອກະສານໃໝ່ (ລາຄາ ຫຼື ໃບບິນ). ທ່ານຍັງສາມາດເລີ່ມທົດລອງທົດສອບການນຳທາງນີ້ໄດ້ຈາກປຸ່ມ 'ທົດລອງທົດສອບ'.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="documents-summary"]',
    content:
      "ສະຫຼຸບຈຳນວນເອກະສານ ແລະ ຍອດເງິນຕາມປະເພດ: ລາຄາທັງໝົດ, ໃບບິນທີ່ຄ້າງຊຳລະ, ໃບຮັບເງິນທີ່ຊຳລະແລ້ວ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="documents-filter"]',
    content:
      "ຄົ້ນຫາ ແລະ ກອງເອກະສານຕາມປະເພດ (ລາຄາ / ໃບບິນ / ໃບຮັບເງິນ) ແລະ ສະຖານະ (ຮ່າງ / ອອກແລ້ວ / ຊຳລະແລ້ວ / ຍົກເລີກ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="documents-table"]',
    content:
      "ຕາຕະລາງສະແດງເອກະສານທັງໝົດ. ກົດເລກທີເອກະສານເພື່ອເບິ່ງລາຍລະອຽດ. ທ່ານສາມາດອອກເອກະສານ, ຍົກເລີກ ຫຼື ແກ້ໄຂ (ເມື່ອສະຖານະຮ່າງ) ຈາກປຸ່ມການກະທຳທີ່ທີ່ຢູ່ທາງຂວາ.",
    placement: "top",
  },
];
